<template>
  <!-- 不支持预览的弹窗 -->
  <div class="cannot">
    <div class="not-preview-pic">
      <svg class="icon" aria-hidden="true" style="width: 295px; height: 162px">
        <use href="#icon-file404"></use>
      </svg>
      <!-- 该文件不支持预览，请下载后查看 -->
      <p style="text-align: center; margin-top: 20px">
        {{ $t("vue_label_file_not_support_preview") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
// 不能预览的盒子
.cannot {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: row;
  background-color: #fff;
  width: 500px;
  height: 500px;
  .not-preview-pic {
    text-align: center;
  }
}
</style>